import axios from "axios";
import { FinalizeRequest, FinalizeResponse } from "@capone/packages-api";
import { config } from "../../config";

import { finalizePackageApiPath } from "../paths";

export const finalizePackageV2 = (
  body: FinalizeRequest
): Promise<FinalizeResponse> =>
  axios
    .post(finalizePackageApiPath, body, {
      baseURL: config.baseURL,
    })
    .then((res) => {
      if (res.data.Response === "Success") {
        return res.data.value;
      }
      throw res.data.error;
    });
